export default {"src":"/_next/static/media/transaction-history.d7b2e0cf.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};